import { HBBuySellRecordVO } from "@/types/general";
import { fetchGetMarketTradeListAsync } from "@/typescript/Services/Api/HuoBiApi";
import SignalRService from "@/typescript/Services/SignalRService";
import { MessageSystemNoticeTypeEnum } from "@/utils/MessageNoticeEnum";
import { defineStore } from "pinia";
import { reactive } from "vue";

export const useTradeDetailStore = defineStore('tradeDetail', {
    state: () => ({
        /**
         * 最大买卖记录
         */
        MaxBuySellRecordCount: 100,
        /**
         * 最大买入记录
         */
        MaxBuyRecordCount: 10,
        /**
         * 最大卖出记录
         */
        MaxSellRecordCount: 10,
        /**
         * 全部交易字典
         */
        AllTransactionDic: {} as { [ch: string]: HBBuySellRecordVO[] },
        /**
         * 买入字典
         */
        BuyTransactionDic: {} as { [ch: string]: HBBuySellRecordVO[] },
        /**
         * 卖出字典
         */
        SellTransactionDic: {} as { [ch: string]: HBBuySellRecordVO[] },
    }),
    actions: {
        /**
         * 初始化监听
         */
        InitEvent() {
            //订阅逐一买卖
            SignalRService.Instance.AddEventOnce(MessageSystemNoticeTypeEnum.TradeDetailData, (d: HBBuySellRecordVO[]) => {
                for (let i = 0; i < d.length; i++) {
                    const v = d[i];
                    const productCode = v.ProductCode;
        
                    this.AllTransactionDic[productCode] ??= reactive([]);
                    this.BuyTransactionDic[productCode] ??= reactive([]);
                    this.SellTransactionDic[productCode] ??= reactive([]);

                    if (this.AllTransactionDic[productCode]!.length >= this.MaxBuySellRecordCount)
                        this.AllTransactionDic[productCode].splice(this.AllTransactionDic[productCode].length - 1, 1);
                    this.AllTransactionDic[productCode].unshift(v);

                    switch (v.Direction) {
                        case "buy": //购买
                            if (this.BuyTransactionDic[productCode]!.length >= this.MaxBuyRecordCount)
                                this.BuyTransactionDic[productCode].splice(this.BuyTransactionDic[productCode].length - 1, 1);
                            this.BuyTransactionDic[productCode].unshift(v);
                            break;
                        case "sell": //卖出
                            if (this.SellTransactionDic[productCode]!.length >= this.MaxSellRecordCount)
                                this.SellTransactionDic[productCode].splice(this.SellTransactionDic[productCode].length - 1, 1);
                            this.SellTransactionDic[productCode].unshift(v);
                            break;
                    }
                }
            });
        },
        /**
         * 加载最新数据
         */
        async LoadDataAysnc(productCode: string) {
            fetchGetMarketTradeListAsync(productCode, 10).then(resp => {
                if (resp.CheckIsOk()) {
                    if (resp.data) {
                        this.AllTransactionDic[productCode] ??= reactive([]);
                        this.BuyTransactionDic[productCode] ??= reactive([]);
                        this.SellTransactionDic[productCode] ??= reactive([]);

                        this.AllTransactionDic[productCode].splice(0);
                        this.BuyTransactionDic[productCode].splice(0);
                        this.SellTransactionDic[productCode].splice(0);
                        for (let i = 0; i < resp.data.length; i++) {
                            const d = resp.data[i];
                            this.AllTransactionDic[productCode].push(d);
                            switch (d.Direction) {
                                case "buy":
                                    if (this.BuyTransactionDic[productCode]!.length >= this.MaxBuyRecordCount)
                                        this.BuyTransactionDic[productCode].splice(this.BuyTransactionDic[productCode].length - 1, 1);
                                    this.BuyTransactionDic[productCode].push(d);
                                    break;
                                case "sell":
                                    if (this.SellTransactionDic[productCode]!.length >= this.MaxSellRecordCount)
                                        this.SellTransactionDic[productCode].splice(this.SellTransactionDic[productCode].length - 1, 1);
                                    this.SellTransactionDic[productCode].push(d);
                                    break;
                            }
                        }
                    }
                }
            });
        }
    }
});